// extracted by mini-css-extract-plugin
module.exports = {"container_s":"styles_container_s__eI07d","otherPosts":"styles_otherPosts__ls7xM"};